import type { IGenericObject } from 'types';

export interface IOfficeLocation {
  locationCode: string;
  locationName: string;
}

export enum PaymentTermApplyFor {
  solid = 'solid',
  liquid = 'liquid',
}

export interface IPaymentTerm {
  paymentTermsCode: string;
  paymentDescription: string;
  paymentDueDate: string;
  applyFor: PaymentTermApplyFor[];
}

export interface ITransportMethod {
  label: string;
  value: string;
}

export interface IMetadataActions {
  loadOfficeLocations: (productType?: string) => void;
  loadPaymentTerms: (productType?: string) => void;
  resetPaymentTerms: () => void;
  loadTransportMethods: () => void;

  resetMetadata: () => void;
}

export interface IMetadataSelectors {
  selectPaymentTerm: (state: IMetadataState, paymentTermCode: string) => IPaymentTerm | any;
  selectPaymentTerms: (state: IMetadataState) => IMetadataState['paymentTerms'];
  selectFilteredPaymentTerms: (
    state: IMetadataState,
    applyFor?: PaymentTermApplyFor,
  ) => IPaymentTerm[] | any;

  selectOfficeLocation: (state: IMetadataState, officeCode: string) => IOfficeLocation | any;
  selectOfficeLocations: (state: IMetadataState) => IMetadataState['officeLocations'];

  selectTransportMethod: (
    state: IMetadataState,
    transportMethodCode: string,
  ) => ITransportMethod | any;
  selectTransportMethods: (state: IMetadataState) => IMetadataState['transportMethods'];
}

export interface IMetadataState {
  officeLocations: Array<IOfficeLocation>;
  officeLocationsLoadedProductType: string | null;
  officeLocationsLoading: boolean;
  officeLocationsError: IGenericObject | null;

  paymentTerms: Array<IPaymentTerm>;
  paymentTermsLoadedProductType: string;
  paymentTermsLoading: boolean;
  paymentTermsError: IGenericObject | null;

  transportMethods: Array<ITransportMethod>;
  transportMethodsLoaded: boolean;
  transportMethodsLoading: boolean;
  transportMethodsError: IGenericObject | null;
}

export type IMetadataContext = {
  actions: IMetadataActions;
  selectors: IMetadataSelectors;
  state: IMetadataState;
};

export interface ILoadMetadata {
  loadOfficeLocationsData?: boolean;
  loadPaymentTermsData?: boolean;
  loadTransportMethodsData?: boolean;
}
